{
  "futuresTitle": "EXALT 合约交易",
  "futuresSubtitle": "实时合约交易面板",
  "liveFuturesMarket": "实时合约市场",
  "perpetualFutures": "永续合约",
  "buyLong": "买入/做多",
  "sellShort": "卖出/做空",
  "cross": "全仓",
  "isolated": "逐仓",
  "market": "市价",
  "limit": "限价",
  "amount": "数量",
  "price": "价格",
  "cost": "花费",
  "available": "可用",
  "margin": "保证金",
  "marginMode": "保证金模式",
  "leverage": "杠杆",
  "orderType": "订单类型",
  "entryPrice": "开仓价格",
  "markPrice": "标记价格",
  "liquidation": "强平价格",
  "takeProfit": "止盈",
  "stopLoss": "止损",
  "tpPrice": "止盈价格",
  "slPrice": "止损价格",
  "reduceOnly": "只减仓",
  "positions": "持仓",
  "openPositions": "当前持仓",
  "positionHistory": "持仓历史",
  "openOrders": "当前委托",
  "orderBook": "订单簿",
  "funding": "资金费率结算",
  "fundingRate": "资金费率",
  "riskLevel": "风险等级",
  "quoteCurrency": "计价货币",
  "bots": "机器人",
  "futuresSettings": "合约设置",
  "normalCandles": "普通K线",
  "smoothCandles": "平滑K线",
  "volatileCandles": "波动K线",
  "lowVolatility": "低波动",
  "normalVolatility": "正常波动",
  "highVolatility": "高波动",
  "zoomSmall": "缩小",
  "zoomMedium": "中等",
  "zoomLarge": "放大",
  "tradingViewChart": "TradingView 图表",
  "mobileFuturesChart": "移动端合约图表",
  "searchMarket": "搜索市场...",
  "searchPair": "搜索交易对...",
  "noOpenPositions": "暂无持仓。",
  "noClosedPositions": "暂无已平仓记录。",
  "openLong": "开多",
  "openShort": "开空",
  "closePosition": "平仓",
  "processing": "处理中...",
  "loading": "加载中...",
  "importantNotice": "重要提示",
  "priceMovementWarning": "在非常规交易时段，价格波动可能受限且流动性可能降低。",
  "serverError": "服务器错误。",
  "sessionExpired": "会话已过期，请重新登录。"
}